import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img_phone.png'
import _imports_1 from '@/assets/img_time.png'
import _imports_2 from '@/assets/img_location.png'


const _withScopeId = n => (_pushScopeId("data-v-1a503acb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "foot-c-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-ct-title" }, "联系我们 & 办公信息", -1))
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"foot-ct-item-img_bg\" data-v-1a503acb><div class=\"foot-ct-item-img_second_bg\" data-v-1a503acb><img class=\"foot-ct-item-img\" src=\"" + _imports_0 + "\" data-v-1a503acb></div></div><div class=\"foot-ct-item-text-div\" data-v-1a503acb><span class=\"foot-ct-item-text-1\" data-v-1a503acb>业务经理</span><span class=\"foot-ct-item-text-2 margin-top-5\" data-v-1a503acb>13167540356</span></div>", 2)
const _hoisted_5 = [
  _hoisted_3
]
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"foot-ct-item-img_bg\" data-v-1a503acb><div class=\"foot-ct-item-img_second_bg\" data-v-1a503acb><img class=\"foot-ct-item-img\" src=\"" + _imports_1 + "\" data-v-1a503acb></div></div><div class=\"foot-ct-item-text-div\" data-v-1a503acb><span class=\"foot-ct-item-text-1\" data-v-1a503acb>办公时间</span><span class=\"foot-ct-item-text-2 margin-top-5\" data-v-1a503acb>8:30 - 18:30，周一到周五</span></div>", 2)
const _hoisted_8 = [
  _hoisted_6
]
const _hoisted_9 = /*#__PURE__*/_createStaticVNode("<div class=\"foot-ct-item-img_bg\" data-v-1a503acb><div class=\"foot-ct-item-img_second_bg\" data-v-1a503acb><img class=\"foot-ct-item-img\" src=\"" + _imports_2 + "\" data-v-1a503acb></div></div><div class=\"foot-ct-item-text-div\" data-v-1a503acb><span class=\"foot-ct-item-text-1\" data-v-1a503acb>公司地址</span><span class=\"foot-ct-item-text-2 margin-top-5\" data-v-1a503acb>河北省廊坊三河市燕郊开发区</span></div>", 2)
const _hoisted_11 = [
  _hoisted_9
]

import {isShowQrCodeDialog} from "@/views/data/CommonData";


export default /*#__PURE__*/_defineComponent({
  __name: 'foot-contact',
  setup(__props) {

const onQRCodeClick = () => {
  isShowQrCodeDialog.value = true
}
const onPhoneClick = () => {
  window.location.href = 'tel:13167540356';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "foot-ct-item",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (onPhoneClick()))
    }, _hoisted_5),
    _createElementVNode("div", {
      class: "foot-ct-item",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (onQRCodeClick()))
    }, _hoisted_8),
    _createElementVNode("div", {
      class: "foot-ct-item",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (onQRCodeClick()))
    }, _hoisted_11)
  ]))
}
}

})